import { render, staticRenderFns } from "./UserFormQuestion.vue?vue&type=template&id=646715bd&scoped=true&"
import script from "./UserFormQuestion.vue?vue&type=script&lang=js&"
export * from "./UserFormQuestion.vue?vue&type=script&lang=js&"
import style0 from "./UserFormQuestion.vue?vue&type=style&index=0&id=646715bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646715bd",
  null
  
)

export default component.exports